<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">عقارات متعددة الوحدات</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">عقارات متعددة الوحدات</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('property_containers_create')" class="row">
          <div class="col text-end">
            <router-link :to="{path: '/propertyContainers/create', query: searchProjectId ? {projectId: searchProjectId} : {}}" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة عقار متعدد الوحدات
            </router-link>
          </div>
        </div>

        <!--FILTER-->
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchMobile" class="form-control" placeholder="جوال العميل">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchTypeId">
                      <option :value="null">نوع العقار</option>
                      <option v-for="r in typesList" :value="r.id" :key="r.id">{{ r.name }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchRegion" @change="getCitiesList">
                      <option :value="null">المنطقة</option>
                      <option v-for="r in regionsList" :value="r.id" :key="r.id">{{ r.name }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select
                      ref="citiesSelect"
                      class="form-control"
                      v-model="searchCity"
                      @change="getNeighborhoodsList"
                    >
                      <option :value="null">المدينة</option>
                      <option v-for="r in citiesList" :value="r.id" :key="r.id">
                        {{ r.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-6 col-sm-3 mb-3 position-relative">
                    <div class="position-relative" ref="neighborhoodDropdown">

                      <button
                        type="button"
                        class="form-control text-end d-flex justify-content-between align-items-center px-3 py-2"
                        @click="searchCity && toggleNeighborhoodDropdown()"
                        :disabled="!searchCity"
                        :class="{ 'bg-light text-muted': !searchCity }"
                        style="cursor:pointer;"
                      >
                        <span class="text-truncate">
                          {{
                            !searchCity
                              ? 'الحي'
                              : (
                                  searchNeighborhood
                                    ? (neighborhoodsList.find(n => n.id == searchNeighborhood) || {}).name || 'الحي'
                                    : 'الحي'
                                )
                          }}
                        </span>

                        <i
                          :class="neighborhoodDropdownOpen ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"
                          class="ms-1 flex-shrink-0"
                        ></i>
                      </button>

                      <div
                        v-show="neighborhoodDropdownOpen"
                        class="position-absolute w-100 bg-white border rounded shadow-sm mt-1 p-2"
                        style="z-index:1050; top:100%;"
                      >
                        <div class="pb-2 border-bottom mb-2">
                          <input
                            ref="neighborhoodSearchInput"
                            type="text"
                            class="form-control form-control-sm"
                            v-model="neighborhoodSearch"
                            placeholder="بحث في الأحياء..."
                            @click.stop
                            @keydown.esc="neighborhoodDropdownOpen = false"
                          >
                        </div>

                        <div style="max-height:220px; overflow-y:auto;" class="px-1">

                          <a
                            class="dropdown-item py-2 rounded"
                            href="#"
                            @click.prevent="selectNeighborhood(null)"
                          >
                            <i class="bi bi-x-circle me-1 text-muted"></i>
                            الكل
                          </a>

                          <a
                            v-for="n in filteredNeighborhoods"
                            :key="n.id"
                            class="dropdown-item py-2 px-3 rounded mb-1"
                            :class="{ 'active bg-primary text-white': searchNeighborhood == n.id }"
                            href="#"
                            @click.prevent="selectNeighborhood(n.id)"
                          >
                            {{ n.name }}
                          </a>

                          <div
                            v-if="filteredNeighborhoods.length === 0"
                            class="text-muted text-center py-3 small"
                          >
                            لا توجد نتائج
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">العقارات</div>
                <span v-if="countRows > 0"
                  class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                  عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الصورة</th>
                            <th>الوصف</th>
                            <th>النوع</th>
                            <th>المدينة</th>
                            <th>تاريخ الإنشاء</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>
                              <router-link v-if="row.PropertyContainerMedia && row.PropertyContainerMedia.length" :to="`/propertyContainers/update/${row.id}`">
                                <img :src="MEDIA_URL+row.PropertyContainerMedia[0].thumbnail" class="img-thumbnail" style="max-width: 150px;" alt="">
                              </router-link>
                            </td>
                            <td>
                              <router-link :to="`/propertyContainers/update/${row.id}`">{{ row.title }}</router-link>
                            </td>
                            <td>{{ (row.PropertyContainerType)? row.PropertyContainerType.name : 'غير معروف' }}</td>
                            <td>{{ (row.City)? row.City.name : 'غير معروف' }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>
                              <router-link :to="`/propertyContainers/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('property_containers_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('property_containers_delete')" class="btn btn-danger btn-sm" @click="deleteProperty(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, checkAccess } from '@/helpers/tools';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'PropertyContainersList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      regionsList: [],
      citiesList: [],
      typesList: [],
      searchTypeId: this.$route.query.typeId || null,
      searchMobile: this.$route.query.mobile || '',
      searchRegion: this.$route.query.region || null,
      searchCity: this.$route.query.city || null,
      searchNeighborhood: this.$route.query.neighborhood || null,
      neighborhoodsList: [],
      neighborhoodSearch: '',
      neighborhoodDropdownOpen: false,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      showDateFilter: false,
      countRows: 0,
      searchProjectId: this.$route.query.projectId || null,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL']),
    filteredNeighborhoods(){
      if(!this.neighborhoodSearch || !this.neighborhoodSearch.trim())
        return this.neighborhoodsList;

      const q = this.neighborhoodSearch.trim().toLowerCase();

      return this.neighborhoodsList.filter(
        n => n.name && n.name.toLowerCase().includes(q)
      );
    }
  },
  methods: {
    checkAccess, 
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.searchTypeId)
        urlQuery.push(`typeId=${this.searchTypeId}`);
      if(this.searchMobile.trim() != '')
        urlQuery.push(`mobile=${this.searchMobile.trim()}`);
      if(this.searchRegion)
        urlQuery.push(`regionId=${this.searchRegion}`);
      if(this.searchCity)
        urlQuery.push(`cityId=${this.searchCity}`);
      if(this.searchNeighborhood)
        urlQuery.push(`neighborhoodId=${this.searchNeighborhood}`);

      if(this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if(this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);
      
      if(this.searchProjectId)
        urlQuery.push(`projectId=${encodeURIComponent(this.searchProjectId)}`);
      
        this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchTypeId !== null && this.searchTypeId !== '' && this.searchTypeId !== false ? { typeId: this.searchTypeId } : {}),
        ...(this.searchMobile !== null && this.searchMobile !== '' && this.searchMobile !== false ? { mobile: this.searchMobile } : {}),
        ...(this.searchRegion !== null && this.searchRegion !== '' && this.searchRegion !== false ? { region: this.searchRegion } : {}),
        ...(this.searchCity !== null && this.searchCity !== '' && this.searchCity !== false ? { city: this.searchCity } : {}),
        ...(this.searchNeighborhood !== null && this.searchNeighborhood !== '' && this.searchNeighborhood !== false ? { neighborhood: this.searchNeighborhood } : {}),
        ...(this.searchDateFrom ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo ? { dateTo: this.searchDateTo } : {}),
        ...(this.searchProjectId ? {projectId: this.searchProjectId} : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/propertyContainers/list?${urlQuery.join('&')}`).then(({data}) => {
        this.rows = data.properties;
        this.regionsList = data.regionsList;
        this.typesList = data.typesList;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    deleteProperty(id, index){
      this.$swal.fire({
        title: "هل تريد تأكيد حذف العقار ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/propertyContainers/delete/${id}`).then(({data}) => {
            let buffer = this.rows;
            buffer.splice(index, 1);
            this.rows = buffer;
            // this.rows.splice(index, 1);
            toast('تم حذف العقار بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف العقار');
          });
        }
      });
    },
    getCitiesList(){
      this.citiesList = [];
      this.searchCity = null;

      this.neighborhoodsList = [];
      this.searchNeighborhood = null;
      this.neighborhoodSearch = '';
      this.neighborhoodDropdownOpen = false;

      if(!this.searchRegion){
        return;
      }

      this.$http
        .get(`/api/admin/cities/list?regionId=${this.searchRegion}&all=1`)
        .then(({data}) => {
          this.citiesList = data.cities;
        })
        .catch(() => {});
    },
    getNeighborhoodsList(){
      this.neighborhoodsList = [];
      this.searchNeighborhood = null;
      this.neighborhoodSearch = '';
      this.neighborhoodDropdownOpen = false;

      if(!this.searchCity){
        return;
      }

      this.$http
        .get(`/api/admin/neighborhoods/list?cityId=${this.searchCity}&all=1`)
        .then(({data}) => {
          this.neighborhoodsList = data.neighborhoods || [];
        })
        .catch(() => {});
    },

    toggleNeighborhoodDropdown(){
      this.neighborhoodDropdownOpen = !this.neighborhoodDropdownOpen;

      if(this.neighborhoodDropdownOpen){
        this.$nextTick(() => {
          if(this.$refs.neighborhoodSearchInput)
            this.$refs.neighborhoodSearchInput.focus();
        });
      }
    },

    selectNeighborhood(id){
      this.searchNeighborhood = id;
      this.neighborhoodDropdownOpen = false;
      this.neighborhoodSearch = '';
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchTypeId = null;
      this.searchMobile = '';
      this.searchRegion = null;
      this.searchCity = null;
      this.searchNeighborhood = null;
      this.neighborhoodsList = [];
      this.neighborhoodSearch = '';
      this.neighborhoodDropdownOpen = false;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.searchProjectId = null;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
    applySelect2Cities(){
      if(!this.$refs.citiesSelect){
        setTimeout(() => this.applySelect2Cities(), 200);
        return;
      }
      const myInstance = this;
      const $el = $(this.$refs.citiesSelect);
      if ($el.hasClass('select2-hidden-accessible')){
        $el.off('change.citiesSelect2');
        $el.select2('destroy');
      }
      $el.select2({ width: '100%' })
        .on('change.citiesSelect2', function () {
          const newVal = $(this).val() || null;
          if(newVal === myInstance.searchCity) return;
          myInstance.searchCity = newVal;
          myInstance.getNeighborhoodsList(); 
        });
    },
  },
  mounted(){
    this._clickOutsideHandler = (e) => {
      if(this.$refs.neighborhoodDropdown && !this.$refs.neighborhoodDropdown.contains(e.target)){
        this.neighborhoodDropdownOpen = false;
      }
    };
    document.addEventListener('click', this._clickOutsideHandler);
    this.applySelect2Cities();
  },

  beforeUnmount(){
    document.removeEventListener('click', this._clickOutsideHandler);
  },

  created(){
    this.getList();
  }
}
</script>